module.exports = __webpack_public_path__ + "img/layout_form_icon.a50b9446.svg";